<h1 mat-dialog-title>Add Reason</h1>
<form [formGroup]="dialogForm">
<mat-form-field appearance="outline">
  <mat-label>Quality Code </mat-label>
  <input type="text" matInput formControlName="reason" [matAutocomplete]="auto" />
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option *ngFor="let reason of reasons" [value]="reason.name">
      {{ reason.name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
</form>

<div mat-dialog-actions class="dialog-footer">
  <button mat-flat-button (click)="cancel()">Cancel</button>
  <button class="btn-save" type="button" mat-flat-button color="primary" class="btn-save"
    [disabled]="dialogForm.invalid" (click)="save()">
    Save
  </button>
</div>